// 自动生成，请勿手动修改

import { ReactComponent as CustomMadeIcon } from '../../assets/icons/custom_made.svg'
import { ReactComponent as CustomerServiceIcon } from '../../assets/icons/customer_service.svg'
import { ReactComponent as DrowIcon } from '../../assets/icons/drow.svg'
import { ReactComponent as ExchangeCodeIcon } from '../../assets/icons/exchange_code.svg'
import { ReactComponent as LogoutIcon } from '../../assets/icons/logout.svg'
import { ReactComponent as OpenVipIcon } from '../../assets/icons/open_vip.svg'

export const SvgIcons = {
  CustomMadeIcon,
  CustomerServiceIcon,
  DrowIcon,
  ExchangeCodeIcon,
  LogoutIcon,
  OpenVipIcon,
}

export const ImgIcons = {
  Detail_IconDown: 'detail/icon_down.png',
  Detail_IconLast: 'detail/icon_last.png',
  Detail_IconNext: 'detail/icon_next.png',
  Detail_IconPlayVideo: 'detail/icon_play-video.png',
  Detail_IconShare: 'detail/icon_share.png',
  Detail_IconStar: 'detail/icon_star.png',
  Detail_IconVipFree: 'detail/icon_vip-free.png',
  Detail_IconVip: 'detail/icon_vip.png',
  Icon_Customer: 'icon__customer.png',
  Icon_Recommend: 'icon__recommend.png',
  Icon_WechatWhite: 'icon__wechat-white.png',
  IconAlipay: 'icon_alipay.png',
  IconAlipay_1: 'icon_alipay_1.png',
  IconAvatar: 'icon_avatar.png',
  IconCheck: 'icon_check.png',
  IconCheck2: 'icon_check2.png',
  IconClose: 'icon_close.png',
  IconCopy: 'icon_copy.png',
  IconCustomMade: 'icon_custom_made.png',
  IconCustomerCheck: 'icon_customer_check.png',
  IconCustomerLogo: 'icon_customer_logo.png',
  IconCustomerService: 'icon_customer_service.png',
  IconCustomerStar: 'icon_customer_star.png',
  IconExchangeCode: 'icon_exchange_code.png',
  IconLihua: 'icon_lihua.png',
  IconLock: 'icon_lock.png',
  IconLogo: 'icon_logo.png',
  IconMLogo: 'icon_m_logo.png',
  IconMobileLogo: 'icon_mobile_logo.png',
  IconOpenVip: 'icon_open_vip.png',
  IconPaySuccess: 'icon_pay_success.png',
  IconPc: 'icon_pc.png',
  IconSearch: 'icon_search.png',
  IconSearch2: 'icon_search2.png',
  IconWepay: 'icon_wepay.png',
  IconWepay_1: 'icon_wepay_1.png',
  IconWepay_2: 'icon_wepay_2.png',
  IconWexin: 'icon_wexin.png',
  Vipcard_Icon_1: 'vipcard/icon_1.svg',
  Vipcard_Icon_2: 'vipcard/icon_2.svg',
  Vipcard_Icon_3: 'vipcard/icon_3.svg',
  Vipcard_Icon_4: 'vipcard/icon_4.svg',
  Vipcard_Icon_5: 'vipcard/icon_5.svg',
  Vipcard_Icon_6: 'vipcard/icon_6.svg',
}